  <template>
    <div class="contain">
      <head-comp></head-comp>
    
      <!-- 内容-->
      <div class="art-box" :style="{minHeight:winHeight.height}">
        <!-- 左边侧边栏 -->
        <aside-comp></aside-comp>
        
        <div class="art-right">
          <ol class="breadcrumb art-here">
            当前位置：
            <li><router-link to="/index">首页</router-link></li>
            <li class="active">{{name}}</li>
          </ol>
          
          <div class="list-txt">
            <div class="list-tit"><span class="glyphicon glyphicon-leaf" aria-hidden="true"></span>{{name}}</div>
            <ul class="list-ul">
              <li v-for="(item,index) in listArr" :key="index">
                <a href="javascript:;" @click="jumpAtc(item)">
                  <i></i>{{item.name}}
                </a>
                <span>{{item.update_time}}</span>
              </li>
            </ul>
            <div class="page">
              <nav class="paging" aria-label="...">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :page-size="pagesize"
                  layout="total,  prev, pager, next, jumper"
                  v-if="total > 0"
                  :total="total">
                </el-pagination>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <!-- 底部-->
      <foot-comp></foot-comp>
       <!-- 预加载 -->
    <page-load v-if="loading"></page-load>
    <!-- 提示框 -->
    <tip :tip="tip" v-show="tipShow"></tip>
    </div>
</template>

<script>
import { getArticles, getArtCate } from "../api/api";
import headComp from "../components/headComp";
import footComp from "../components/footComp";
import asideComp from "../components/asideComp";
import pageLoad from "../pageload/pageload";
export default {
  components: { footComp, headComp, asideComp, pageLoad },
  data() {
    return {
      listArr: {}, //列表数据
      page: 1,
      pagesize: 10,
      total: 0,
      winHeight: {
        //监听屏幕高度
        height: ""
      },
      tip: {}, //提示语
      loading: true, //预加载
      tipShow: false, //提示框默认状态
      name: "" //单个栏目的名称
    };
  },
  created() {
    window.addEventListener("resize", this.getHeight);
    this.getHeight(); //获取屏幕的高度
    this._getArticles(); //获取文章列表
  },
  methods: {
    //获取文章列表
    _getArticles(val) {
      let module = {
        sch_id: 1,
        cate_id: this.$route.params.cid,
        page: val,
        pagesize: this.pagesize
      };
      this.loading = true;
      getArticles(module)
        .then(res => {
          this.loading = false;
          if (res.status && res.data && res.data.arts.length > 0) {
            this.name = res.data.name;
            this.total = parseInt(res.total);
            this.listArr = res.data.arts;
          } else {
            this.tipCtr("暂无数据");
          }
        })
        .catch(err => {
          this.loading = false;
          this.tipCtr("未找到相关数据,请重新加载");
        });
    },
    //获取屏幕的高度
    getHeight() {
      this.winHeight.height =
        document.documentElement.clientHeight - 130 - 120 - 120 + "px";
    },
    //提示框函数
    tipCtr(text) {
      this.tip = text;
      this.tipShow = true;
      setTimeout(() => {
        this.tipShow = false;
      }, 1200);
    },
    handleSizeChange(val) {
      this.page = val;
      this._getArticles(val);
    },
    handleCurrentChange(val) {
      this.page = val;
      this._getArticles(val);
    },
    jumpAtc(item) {
      this.$router.push({ path: "/article/" + item.cate_id + "/" + item.id });
    }
  },
  watch: {
    $route(to, from) {
      this._getArticles(); //获取文章列表
    }
  }
};
</script>

<style scoped>
.contain {
  background: url("../assets/imgs/bk.png");
}
/*内容页*/
.art-banner {
  width: 1200px;
  margin: 20px auto 0;
  height: 100px;
  background-size: cover !important;
}
.art-box {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
  overflow: hidden;
}
/*列表页*/
.list-txt {
  background: #ffffff;
  width: 100%;
  padding: 0 20px;
  min-height: 300px;
  border: 1px solid #ddd;
}
.list-tit {
  color: #428bca;
  font-size: 16px;
  font-weight: bold;
  height: 60px;
  width: 100%;
  border-bottom: 1px #ddd solid;
  text-align: left;
  line-height: 60px;
}
.list-tit span {
  margin-right: 10px;
  font-size: 20px;
  top: 6px;
}
.list-ul li {
  height: 50px;
  border-bottom: 1px #ddd dashed;
}
.list-ul li a {
  position: relative;
  text-indent: 20px;
  color: #333;
  font-size: 14px;
  display: inline-block;
  height: 50px;
  line-height: 50px;
  width: 50%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.list-ul li:hover a {
  color: red;
}
.list-ul li a i {
  width: 4px;
  height: 4px;
  background: #666;
  border-radius: 100%;
  position: absolute;
  left: 6px;
  top: 24px;
}
.list-ul li:hover a i {
  background: red;
}
.list-ul li span {
  color: #999;
  float: right;
  font-size: 12px;
  line-height: 50px;
}
/*右边内容*/
.art-right {
  width: 875px;
  float: right;
}
.art-here {
  background: #ffffff;
  border-radius: 0;
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid #ddd;
}
.paging ul li a {
  margin: 0 2px;
}
.page {
  text-align: center;
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/view/list.vue